// 1x == 8px
export enum MarginSize {
  x1 = '1x',
  x2 = '2x',
  x3 = '3x',
  x4 = '4x',
}

export interface AssetChildComponentSpacing {
  margin?: MarginSize
  marginTop?: MarginSize
  marginBottom?: MarginSize
}
